import { render, staticRenderFns } from "./attestationList.vue?vue&type=template&id=b0c08a96&scoped=true&"
import script from "./attestationList.vue?vue&type=script&lang=js&"
export * from "./attestationList.vue?vue&type=script&lang=js&"
import style0 from "./attestationList.vue?vue&type=style&index=0&id=b0c08a96&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c08a96",
  null
  
)

export default component.exports